import React from 'react';
import {
  Container,
  Row,
  Col,
  Input,
  FormGroup,
  Button,
  Label,
  Navbar,
  NavbarBrand,
  Nav,
  NavbarText,
  Jumbotron,
  Card,
} from 'reactstrap';
import bg from '../assets/images/landing-banner.png';
import screen1 from '../assets/images/screen1.png';
import scr1 from '../assets/images/scr1.png';
import scr2 from '../assets/images/scr2.png';
import scr3 from '../assets/images/scr3.png';
import scr4 from '../assets/images/scr4.png';
import shape from '../assets/images/shape.png';
import logo from '../assets/images/logo.png';
import footer from '../assets/images/footer.png';
import { Link } from 'react-router-dom';
import { SIGNIN_PATH } from '../utils/AppRoutes';

function GeneralLandingPage() {
  return (
    <div>
      <div className="landing-page">
        <section className="banner" style={{ backgroundImage: `url(${bg})` }}>
          {/* navbar */}
          <Navbar color="light" light expand="md" sticky="top">
            <NavbarBrand href="/">
              <img src={logo} />
            </NavbarBrand>
            {/* <NavbarToggler onClick={toggle} /> */}
            <Nav className="ml-auto" navbar>
              {/* <NavItem>
              <NavLink href="/components/">Components</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="https://github.com/reactstrap/reactstrap">GitHub</NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Options
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>
                  Option 1
                </DropdownItem>
                <DropdownItem>
                  Option 2
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem>
                  Reset
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            </Nav>
            <NavbarText>
              <Link to={SIGNIN_PATH}>
                <Button color="primary">SIGN IN</Button>
              </Link>
            </NavbarText>
          </Navbar>
          {/* banner */}

          <Jumbotron>
            <Row>
              <Col sm="12" md={{ size: 8, offset: 2 }}>
                <h1 className="display-3">
                  Keep Your Community Moving Forward
                  <br /> With PayForm.US
                </h1>
                <p className="lead mt-lg-4">
                  PayGov.US is now offering an easy-to-use online form builder
                  that effortlessly streamlines workflows and processing.
                  PayForm.US allows citizens to complete forms and process
                  payments online AT <b>NO COST TO YOU!</b>
                </p>

                <p className="lead">
                  <a href="#more" className="btn btn-primary" color="primary">
                    Learn More
                  </a>
                </p>
              </Col>
            </Row>

            <Row>
              <Col sm="12" md={{ size: 8, offset: 2 }}>
                <img src={screen1} className="screen1" />
              </Col>
            </Row>
          </Jumbotron>
        </section>

        {/* features */}

        <section className="features" id="more">
          <Container>
            <Row>
              <Col md="3">
                <div className="box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM262.2 478.8c-4 1.6-8.4 1.6-12.3 0C152 440 48 304 48 128c0-6.5 3.9-12.3 9.8-14.8l192-80c3.9-1.6 8.4-1.6 12.3 0l192 80c6 2.5 9.9 8.3 9.8 14.8.1 176-103.9 312-201.7 350.8zm136.2-325c-4.7-4.7-12.3-4.7-17-.1L218 315.8l-69-69.5c-4.7-4.7-12.3-4.7-17-.1l-8.5 8.5c-4.7 4.7-4.7 12.3-.1 17l85.9 86.6c4.7 4.7 12.3 4.7 17 .1l180.5-179c4.7-4.7 4.7-12.3.1-17z" />
                    </svg>
                  </span>

                  <h4>Safe and Secure</h4>
                  <p>
                    PayGov.US has been a reliable and trusted payment processing
                    company for 2 decades and is committed to protecting your
                    private and personal information.
                  </p>
                </div>
              </Col>
              <Col md="3">
                <div className="box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 512"
                    >
                      <path d="M191.9 259.3L73.7 222.2C49.2 214.5 32 189 32 160.3 32 124.8 57.6 96 89 96h73.8c22.2 0 43.3 8.6 60.1 24.5 3.1 2.9 7.8 3.2 11 .3l11.9-10.8c3.4-3.1 3.6-8.4.4-11.6-22.8-22-52.7-34.5-83.3-34.5H144V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H89c-49.1 0-89 43.2-89 96.3 0 42.6 26.4 80.6 64.1 92.4l118.2 37.1c24.6 7.7 41.7 33.2 41.7 61.9 0 35.4-25.6 64.3-57 64.3H93.2c-22.2 0-43.3-8.6-60.1-24.5-3.1-2.9-7.8-3.2-11-.3L10.3 402c-3.3 3-3.6 8.4-.3 11.5 22.8 22 52.7 34.5 83.3 34.5H112v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h23c49.1 0 89-43.2 89-96.3 0-42.5-26.4-80.5-64.1-92.4z" />
                    </svg>
                  </span>

                  <h4>Cost Cutting</h4>
                  <p>
                    With PayForm.US you can move away from costly paper
                    processing and go online with updated services{' '}
                    <b>AT NO COST TO YOU!</b>.
                  </p>
                </div>
              </Col>
              <Col md="3">
                <div className="box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M334.89 121.63l43.72-71.89C392.77 28.47 377.53 0 352 0H160.15c-25.56 0-40.8 28.5-26.61 49.76l43.57 71.88C-9.27 240.59.08 392.36.08 412c0 55.23 49.11 100 109.68 100h292.5c60.58 0 109.68-44.77 109.68-100 0-19.28 8.28-172-177.05-290.37zM160.15 32H352l-49.13 80h-93.73zM480 412c0 37.49-34.85 68-77.69 68H109.76c-42.84 0-77.69-30.51-77.69-68v-3.36c-.93-59.86 20-173 168.91-264.64h110.1C459.64 235.46 480.76 348.94 480 409zM285.61 310.74l-49-14.54c-5.66-1.62-9.57-7.22-9.57-13.68 0-7.86 5.76-14.21 12.84-14.21h30.57a26.78 26.78 0 0 1 13.93 4 8.92 8.92 0 0 0 11-.75l12.73-12.17a8.54 8.54 0 0 0-.65-13 63.12 63.12 0 0 0-34.17-12.17v-17.6a8.68 8.68 0 0 0-8.7-8.62H247.2a8.69 8.69 0 0 0-8.71 8.62v17.44c-25.79.75-46.46 22.19-46.46 48.57 0 21.54 14.14 40.71 34.38 46.74l49 14.54c5.66 1.61 9.58 7.21 9.58 13.67 0 7.87-5.77 14.22-12.84 14.22h-30.61a26.72 26.72 0 0 1-13.93-4 8.92 8.92 0 0 0-11 .76l-12.84 12.06a8.55 8.55 0 0 0 .65 13 63.2 63.2 0 0 0 34.17 12.17v17.55a8.69 8.69 0 0 0 8.71 8.62h17.41a8.69 8.69 0 0 0 8.7-8.62V406c25.68-.64 46.46-22.18 46.57-48.56.02-21.5-14.13-40.67-34.37-46.7z" />
                    </svg>
                  </span>

                  <h4>Money Making</h4>
                  <p>
                    At PayForm.US we make it fast and easy for your customers to
                    pay. Increase your revenue with accelerated transfer of
                    funds and shertened collection times.
                  </p>
                </div>
              </Col>

              <Col md="3">
                <div className="box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <path d="M480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm0-160c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm80.1 212c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9C7.2 341.3 0 363.4 0 387.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM352 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zm271.7-114.9C606.4 291.5 577 278 546.8 278c-27.8 0-34.8 10-66.8 10s-39-10-66.8-10c-13.2 0-26.1 3-38.1 8.1 15.2 15.4 18.5 23.6 20.2 26.6 5.7-1.6 11.6-2.6 17.9-2.6 21.8 0 30 10 66.8 10s45-10 66.8-10c21 0 39.8 9.3 50.4 25 7.1 10.5 10.9 22.9 10.9 35.7V408c0 4.4-3.6 8-8 8H416c0 17.7.3 22.5-1.6 32H600c22.1 0 40-17.9 40-40v-37.3c0-19.9-6-38.3-16.3-53.6z" />
                    </svg>
                  </span>

                  <h4>User-Oriented</h4>
                  <p>
                    PayForm.US simplifies the reporting and reconciliation
                    process, making it easier than ever to effectively and
                    efficiently manage funds.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="ultimate">
          <Container>
            <Row>
              <Col md="6" className="left item-center">
                <img src={scr1} />
                <img className="shape" src={shape} />
              </Col>

              <Col md="6" className="right">
                <h3 className="text-center">The Value of Payform.US</h3>
                <p></p>
                <Row>
                  <Col md="6" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>Safety and Security</h4>
                      <p>
                        Protect your staff and community with contactless
                        processing options
                      </p>
                    </div>
                  </Col>

                  <Col md="6" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>Convenience</h4>
                      <p>
                        Citizens appreciate how easy our platform makes it to
                        complete documents and process payments from anywhere.
                      </p>
                    </div>
                  </Col>

                  <Col md="6" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>Transparency</h4>
                      <p>
                        With documents online, your customers can access all the
                        information they need at any time.
                      </p>
                    </div>
                  </Col>

                  <Col md="6" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>Communication</h4>
                      <p>
                        Interact with your community effectively in real-time.
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>

          <Container>
            <Row>
              <Col md="2"></Col>

              <Col md="4" className="right">
                <h3 className="text-center">Quality Features</h3>

                <p className="mb-lg-5 text-center">
                  Accomplish More With Less!
                </p>

                <Row>
                  <Col md="12" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>
                        Our Admin Dashboard supports multiple users, keeping
                        everything your agency needs in one place.
                      </h4>
                    </div>
                  </Col>

                  <Col md="12" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>
                        Real-time reporting and confirmation notifications keep
                        the customer and your agency informed.
                      </h4>
                    </div>
                  </Col>

                  <Col md="12" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>Easily search for records or payments.</h4>
                    </div>
                  </Col>

                  <Col md="12" className="mb-lg-5">
                    <div class="process-circle bg-primary"></div>

                    <div className="info">
                      <h4>
                        Create custom URLs to direct customers quickly from a
                        website to appropriate documents.
                      </h4>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col md="6" className="left item-center">
                <img className="shape" src={shape} />

                <img className="mr-auto" src={scr2} />
              </Col>
            </Row>
          </Container>
        </section>

        {/* screen shot */}

        <section className="screen-shot">
          <Container className="mt-2">
            <Row>
              <Col sm="12" md={{ size: 6, offset: 3 }}>
                <h3 className="text-center">PayForm.US makes it simple</h3>
                <p className="text-center">
                  <b>We</b> offer comprehensive training for staff, a
                  step-by-step user guide, and a customer service phone number
                  with live operators to support our agencies.
                </p>
              </Col>
              {/* slider */}
              <div className="mt-lg-5">
                <Row>
                  <Col md="4">
                    <Card body>
                      <img className="w-100" src={scr3} />
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card body>
                      <img className="w-100" src={scr4} />
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card body>
                      <img className="w-100" src={scr2} />
                    </Card>
                  </Col>
                </Row>
              </div>
            </Row>
          </Container>
        </section>

        <section
          className="footer"
          style={{ backgroundImage: `url(${footer})` }}
        >
          <Container>
            <Row>
              <Col sm="12" md={{ size: 4, offset: 4 }} className="form">
                <h3 className="text-center">Contact Us:</h3>
                <p className="text-center">
                  Our team is eager to answer any questions you have, so let's
                  connect and schedule a live demo today!
                </p>

                <div className="mt-lg-5">
                  <FormGroup>
                    <Label for="">Name</Label>
                    <Input type="text" name="" id="" placeholder="" />
                  </FormGroup>

                  <FormGroup>
                    <Label for="exampleEmail">Email</Label>
                    <Input
                      type="email"
                      name="email"
                      id="exampleEmail"
                      placeholder=""
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="">Subject</Label>
                    <Input type="text" name="" id="" placeholder="" />
                  </FormGroup>

                  <FormGroup>
                    <Label for="">Message</Label>
                    <Input
                      type="textarea"
                      name=""
                      id=""
                      row="5"
                      placeholder=""
                    />
                  </FormGroup>

                  <Button color="primary" block>
                    SUBMIT
                  </Button>
                </div>
              </Col>
            </Row>

            <Row className="info">
              <Col md="3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path d="M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z" />
                </svg>
                <h4>Address</h4>
                <p>
                  5144 E.Stop 11 Rd.
                  <br />
                  Indianapolis,IN 46237
                </p>
              </Col>
              <Col md="3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z" />
                </svg>

                <h4>Email</h4>
                <p>info@paygov.us</p>
                {/* <p>help@domain.com</p> */}
              </Col>
              <Col md="3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path d="M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z" />
                </svg>

                <h4>Phone</h4>
                <p>
                  Toll Free
                  <br />
                  1-866-480-8552
                </p>
                {/* <p>+44 (0) 123 456 7890</p> */}
              </Col>
              <Col md="3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M392 304h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0 128h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zM80 128H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h32a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48zm16 336a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V176a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm296-96h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-128 64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm216-205.06v-53.69a32 32 0 0 0-9.38-22.63L393.38 9.38A32 32 0 0 0 370.75 0H208a48 48 0 0 0-48 48v416a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V208a47.87 47.87 0 0 0-32-45.06zM384 45.25L434.75 96H384zM192 48a16 16 0 0 1 16-16h144v64a32 32 0 0 0 32 32h64v64H192zm288 416a16 16 0 0 1-16 16H208a16 16 0 0 1-16-16V224h288zm-152-32h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-64 0h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z" />
                </svg>

                <h4>Fax</h4>
                <p>1-317-807-4333</p>
                {/* <p>+44 (0) 123 456 7890</p> */}
              </Col>
            </Row>
          </Container>
        </section>

        <section className="footer-logo">
          <Container>
            <Row>
              <Col md="4">
                <img src={logo} />
              </Col>
              <Col md="4" className="item-center justify-content">
                <p>©2021 payGOV.Us</p>
              </Col>
              {/*<Col md="4" className="social">
                <a href="">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
                  </svg>
                </a>
                <a href="">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z" />
                  </svg>
                </a>
                <a href="">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z" />
                  </svg>
                </a>

                <a href="">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                  </svg>
                </a>
              </Col> */}
            </Row>
          </Container>
        </section>
      </div>
    </div>
  );
}

export default GeneralLandingPage;
